<template>
  <div class="amount">
    <div class="container">
      <div v-for="(item, key, index) in data" :key="index" class="block">
        <div class="amount-title">
          <p>{{ $t(key) }}</p>
        </div>
        <div class="amount-main">
          <p
            :class="[
              'quantity',
              { customersAmount: key === 'customersAmount' },
              { satisfiedCustomersAmount: key === 'satisfiedCustomersAmount' },
              key === 'generalSatisfaction'
                ? getGeneralSatisfactionClass(item.quantity)
                : ''
            ]"
          >
            {{ item.quantity }}
          </p>
          <div class="comparison" :class="getComparisonClass(item.comparison)">
            <span>{{ getComparison(item.comparison) }}</span>
            <p>{{ $t('compareTo') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Amount',
  props: ['data'],
  methods: {
    getComparison(comparison: string) {
      const value = (comparison || '').trim();

      return !value || value === '-0%' ? '0%' : value;
    },
    getGeneralSatisfactionClass(quantity: string) {
      const num = parseInt(quantity.replace('%', ''), 10);
      const index = Math.min(10, Math.max(0, Math.round(num / 10)));

      return `satisfaction-${index}`;
    },
    getComparisonClass(comparison: string) {
      if (comparison === '') return 'disable';
      if (comparison === '0%') return 'disable';
      if (comparison === '-0%') return 'disable';
      if (comparison.includes('-')) return 'negative';
      if (!comparison.startsWith('+')) return 'positive';

      return '';
    }
  }
})
export default class Amount extends Vue {}
</script>

<style lang="scss" scoped>
.amount {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    width: 100%;
    max-width: 1182px;
    .block {
      height: 217px;
      width: 360px;
      border: 1px solid $border;
      border-radius: 4px;
      @media (max-width: 1366px) {
        width: 336px;
      }
      @media (max-width: 1280px) {
        width: 302px;
      }
      .amount-title {
        padding: 12px;
        font-size: 15px;
        line-height: 14px;
        border-bottom: 1px solid $border;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        p {
          color: $lineColor;
        }
      }
      .amount-main {
        flex-direction: column;
        display: flex;
        .quantity {
          font-size: 64px;
          text-align: center;
          padding: 43px 0px;
          &.customersAmount {
            color: $label;
          }
          &.satisfiedCustomersAmount {
            color: $positive;
          }
          &.satisfaction-0 {
            color: #e2523f;
          }
          &.satisfaction-1 {
            color: #e8633a;
          }
          &.satisfaction-2 {
            color: #ed7436;
          }
          &.satisfaction-3 {
            color: #f18537;
          }
          &.satisfaction-4 {
            color: #f39737;
          }
          &.satisfaction-5 {
            color: #f19e37;
          }
          &.satisfaction-6 {
            color: #e29b49;
          }
          &.satisfaction-7 {
            color: #c48f5c;
          }
          &.satisfaction-8 {
            color: #a3836a;
          }
          &.satisfaction-9 {
            color: #738c7b;
          }
          &.satisfaction-10 {
            color: #47987f;
          }
        }
        .comparison {
          span {
            font-size: 13px;
            margin: 0 12px;
            padding: 2px 7px;
            border-radius: 21px;
          }
          p {
            display: inline-block;
            font-size: 15px;
            line-height: 14px;
            color: $lineColor;
          }
          &.positive {
            span {
              border: 1px solid $positiveBorder;
              background-color: $positiveBackground;
              color: $positive;
            }
          }

          &.negative {
            span {
              border: 1px solid $negativeBorder;
              background-color: $negativeBackground;
              color: $negative;
            }
          }
          &.disable {
            span {
              border: 1px solid $disableBorder;
              background-color: $disableBackground;
              color: $label;
            }
          }
        }
      }
    }
  }
}
</style>
